// import { H } from '../../src/index.js'
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
import { video } from "../../../src/js/core/app";
import { backgroundVideo } from "../../../src/js/core/app";
import { marquee } from "../../../src/js/core/app";

let tlLines;

export class Header {
  constructor() {
    this.main = document.querySelector(`.main`);
    this.footer = document.querySelector(`.footer`);
    this.header = document.querySelector(`.header--wrap`);
    this.logo = document.querySelector(`.header--top__logo-big`);
    this.play = document.querySelector(`.header--button`);
    this.close = document.querySelector(`.close--video`);
    this.lines = [...document.querySelectorAll(`.js-line`)];
    this.videoWrap = document.querySelector(`.video--wrap`);
    this.videoText = document.querySelector(`.video--text`);
    this.init();
  }

  handlePlayClick = () => {
    this.play.classList.add(`no-click`);
    if (this.close.classList.contains(`no-click`)) {
      this.close.classList.remove(`no-click`);
    }
    gsap.to(window, { duration: 1, scrollTo: { y: 0 } });
    tlLines = gsap.timeline({ paused: false }).staggerFromTo(
      this.lines,
      1,
      { y: "100%" },
      {
        ease: "Power3.easeIn",
        y: "0",
      },
      0.03,
      0,
      () => {
        tlLines = gsap.timeline({ paused: false }).staggerTo(
          this.lines,
          1,
          {
            ease: "Power3.easeIn",
            y: "-100%",
          },
          0.03,
          () => {}
        );
        gsap.to(this.logo, 1, {
          y: "-100%",
          ease: "Power3.easeIn",
          delay: 0,
        });
        this.main.classList.add(`hidden`);
        this.footer.classList.add(`hidden`);
        this.videoWrap.classList.remove("hidden");

        if (window.innerWidth > 800) {
          video.play();
          if (video.video.muted) {
            video.video.muted = false;
          }
        } else {
          video.play();
          document.addEventListener(`click`, () => {
            video.video.muted = false;
            gsap.to(this.videoText, 0.5, {
              opacity: 0,
            });
          });
        }

        marquee.timeline.pause();
        backgroundVideo.pause();
      }
    );
  };

  handleCloseClick = () => {
    video.pause();
    this.close.classList.add(`no-click`);
    tlLines = gsap.timeline({ paused: false }).staggerFromTo(
      this.lines,
      1,
      { y: "100%" },
      {
        ease: "Power3.easeIn",
        y: "0",
      },
      0.03,
      0,
      () => {
        tlLines = gsap.timeline({ paused: false }).staggerTo(
          this.lines,
          1,
          {
            ease: "Power3.easeIn",
            y: "-100%",
          },
          0.03,
          () => {}
        );

        this.main.classList.remove(`hidden`);
        this.footer.classList.remove(`hidden`);
        this.videoWrap.classList.add("hidden");
        this.play.classList.remove(`no-click`);

        marquee.timeline.resume();
        backgroundVideo.play();
      }
    );
    gsap.to(this.logo, 1, {
      y: "0%",
      ease: "Power3.easeIn",
      delay: 0,
    });
  };

  handleLoad = () => {
    this.main.classList.add(`hidden`);
    this.footer.classList.add(`hidden`);
    tlLines = gsap
      .timeline({ paused: false })

      .staggerTo(
        this.lines,
        1,
        {
          ease: "Power3.easeIn",
          y: "-100%",
        },
        0.03,
        0,
        () => {
          this.main.classList.remove(`hidden`);
          this.footer.classList.remove(`hidden`);
        }
      );
  };

  bindClick = () => {
    this.play.addEventListener(`click`, this.handlePlayClick);
    this.close.addEventListener(`click`, this.handleCloseClick);
  };

  init = () => {
    this.bindClick();
    this.handleLoad();
  };
}
